// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H22V7H2V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 9H22V22L2 22V9ZM18 14.5V12.5H6V14.5L18 14.5ZM14 18.5V16.5L6 16.5V18.5L14 18.5Z"}}]};

const FormFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'form-filled',
    ref,
    icon: element,
  },
));

FormFilledIcon.displayName = 'FormFilledIcon';

export default FormFilledIcon;
